module.exports = __webpack_public_path__ + "img/xxnl-banner1.200828a9.png";